/*
 *   File : radio.js
 *   Author : https://evoqins.com
 *   Description : Custom radio select component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

//Custom components
import { Icon } from '../Icon';

const CustomRadioButton = (props) => {

    // handle select multiple 
    const handleSelect = () => {
        if (props.selected.includes(props.data.id)) {
            props.handleSelect(props.selected.filter(id => id !== props.data.id));
        } else {
            props.handleSelect([...props.selected, props.data.id]);
        }
    };

    return (
        <>
            {
                props.multiple === true ?
                    <div className='d-flex gap-1 align-items-center cursor-pointer'
                        onClick={handleSelect}>
                        <Icon icon={props.selected.includes(props.data.id) ? "radio-active" : "radio-inactive"}
                            size="16px"
                            className="d-flex" />
                        <p className={`${props.labelStyle} ${props.selected.includes(props.data.id) ? 'e-font-weight-600 cursor-default' : 'e-font-weight-400 cursor-pointer'} mb-0 e-text-outer-space e-alt-font-lato e-font-14 line-height-20px`}>
                            {props.data.label}
                        </p>
                    </div>
                    :
                    props.type === 2 ?

                        <div className='d-flex gap-1 align-items-center cursor-pointer'
                            onClick={() => props.handleSelect(props.data)}>
                            <Icon icon={props.selected === props.data.option_description ? "radio-active" : "radio-inactive"}
                                size="16px"
                                className="d-flex" />
                            <p className={`${props.labelStyle} ${props.selected === props.data.option_description ? 'e-font-weight-500 cursor-default' : 'e-font-weight-400 cursor-pointer'} mb-0 e-text-chinese-black e-alt-font-lato e-font-14 line-height-20px`}>
                                {props.data.option_description}
                            </p>
                        </div>
                        :
                        <div className='d-flex gap-1 align-items-center cursor-pointer'
                            onClick={() => props.handleSelect(props.data.id)}>
                            <Icon icon={props.selected === props.data.id ? "radio-active" : "radio-inactive"}
                                size="16px"
                                className="d-flex" />
                            <p className={`${props.labelStyle} ${props.selected === props.data.id ? 'e-font-weight-500 cursor-default' : 'e-font-weight-400 cursor-pointer'} mb-0 e-text-chinese-black e-alt-font-lato e-font-14 line-height-20px`}>
                                {props.data.label}
                            </p>
                        </div>
            }
        </>
    )
}

export default CustomRadioButton;
